import { createRootRoute, Outlet } from "@tanstack/react-router";
import { ApiProvider } from "@/components/ApiProvider";
import { Flex } from "@radix-ui/themes";

export const Route = createRootRoute({
  component: () => (
    <ApiProvider>
      <Flex 
        align="center" 
        justify="center" 
        width="100vw" 
        height="100vh"
      >
        <Outlet />
      </Flex>
    </ApiProvider>
  ),
});
